import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { isNotNullOrUndefined, System } from "ngx-core-services";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Observable, Subject } from "rxjs";

import { CreateBlockReduxSupport, IReduxBlock } from "../../store/helpers/decorator";
import { selectedSystem, SystemDefinition, SystemsState } from "../../store";
import { tap } from "rxjs/operators";

@CreateBlockReduxSupport()
@Component({
  selector: 'lib-selected-system-support',
  standalone: true,
  imports: [
    CommonModule,
  ],
  template: `<ng-container *ngIf="{ sDefinition: systemDefinition$ | async }"></ng-container>`,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedSystemSupportComponent implements IReduxBlock {
  @Input() refresh$ = new Subject<void>();
  _refresh$ = new Observable<boolean>();

  readonly system$ = new BehaviorSubject<System|undefined>(undefined);
  @Input() system?: System;

  @Output() readonly systemDefinition = new EventEmitter<SystemDefinition>();

  readonly _instanceId$: Observable<string> = new Observable<string>();

  readonly systemDefinition$ = this.store.select(selectedSystem).pipe(
    isNotNullOrUndefined(),
    tap((system) => this.systemDefinition.emit(system)),
  );

  constructor(
    readonly store: Store<SystemsState>,
    readonly el: ElementRef,
    readonly renderer: Renderer2,
  ) { }
}
